import { render, staticRenderFns } from "./FloatOnMask.vue?vue&type=template&id=5ec3cea4&scoped=true&"
import script from "./FloatOnMask.vue?vue&type=script&lang=js&"
export * from "./FloatOnMask.vue?vue&type=script&lang=js&"
import style0 from "./FloatOnMask.vue?vue&type=style&index=0&id=5ec3cea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3cea4",
  null
  
)

export default component.exports